<template>
  <section class="water-usage-charts">
    <base-e-chart class="chart-card" :option="temperatureOption" tooltip-autoplay />
    <base-e-chart class="chart-card" :option="dailyWaterOption" tooltip-autoplay />
    <base-e-chart class="chart-card" :option="tdsOption" tooltip-autoplay />
  </section>
</template>

<script>
import {
  createDateLabels,
  parseHistoryData
} from "../../utils/protocol/history";
import {
  createDarkLineOption,
  createGradientLineSeries
} from "../../utils/echarts";
import BaseEChart from "../common/BaseEChart.vue";

export default {
  name: "WaterUsageCharts",
  components: { BaseEChart },
  props: {
    protocol: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    history() {
      return parseHistoryData(this.protocol);
    },
    temperatureOption() {
      const history = this.history;
      const length = Math.max(
        history.temperatures.length,
        history.peakPureWaterFlow.length
      );

      return createDarkLineOption({
        labels: createDateLabels(length),
        series: [
          createGradientLineSeries({
            name: "最低温度 ℃",
            data: history.temperatures,
            color: "#33FF6A",
            areaStartColor: "rgba(51, 255, 106, 0.48)"
          }),
          createGradientLineSeries({
            name: "纯水流量峰值 m³/H",
            data: history.peakPureWaterFlow,
            color: "#0095FF",
            areaStartColor: "rgba(0, 149, 255, 0.48)"
          })
        ]
      });
    },
    dailyWaterOption() {
      const history = this.history;
      const length = Math.max(
        history.dailyInletWaterFlow.length,
        history.dailyPureWaterFlow.length
      );

      return createDarkLineOption({
        title: "每日用水/制水",
        labels: createDateLabels(length),
        series: [
          createGradientLineSeries({
            name: "原水m³",
            data: history.dailyInletWaterFlow,
            color: "#FF9D00",
            areaStartColor: "rgba(255, 157, 0, 0.48)"
          }),
          createGradientLineSeries({
            name: "纯水m³",
            data: history.dailyPureWaterFlow,
            color: "#33FF6A",
            areaStartColor: "rgba(51, 255, 106, 0.48)"
          })
        ]
      });
    },
    tdsOption() {
      const history = this.history;
      const length = Math.max(history.inletTds.length, history.pureWaterTds.length);

      return createDarkLineOption({
        title: "TDS",
        labels: createDateLabels(length),
        series: [
          createGradientLineSeries({
            name: "进水TDS值",
            data: history.inletTds,
            color: "#FF9D00",
            areaStartColor: "rgba(255, 157, 0, 0.48)"
          }),
          createGradientLineSeries({
            name: "纯水TDS值",
            data: history.pureWaterTds,
            color: "#33FF6A",
            areaStartColor: "rgba(51, 255, 106, 0.48)"
          })
        ]
      });
    }
  }
};
</script>

<style scoped>
.water-usage-charts {
  position: absolute;
  top: 510px;
  left: 512px;
  display: flex;
}

.chart-card {
  width: 323px;
  height: 228px;
}
</style>
